var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico-instagram",
    transform: "translate(-0.056 -0.099)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_simple-instagram",
    "data-name": "Icon simple-instagram",
    d: "M19.9,0C14.5,0,13.821.025,11.7.119a14.676,14.676,0,0,0-4.831.925A9.747,9.747,0,0,0,3.34,3.34a9.711,9.711,0,0,0-2.3,3.526A14.633,14.633,0,0,0,.119,11.7C.02,13.821,0,14.5,0,19.9s.025,6.082.119,8.2a14.685,14.685,0,0,0,.925,4.831,9.76,9.76,0,0,0,2.3,3.526,9.733,9.733,0,0,0,3.526,2.3,14.694,14.694,0,0,0,4.831.925c2.123.1,2.8.119,8.2.119s6.082-.025,8.2-.119a14.728,14.728,0,0,0,4.831-.925,10.172,10.172,0,0,0,5.822-5.822,14.685,14.685,0,0,0,.925-4.831c.1-2.123.119-2.8.119-8.2s-.025-6.082-.119-8.2a14.719,14.719,0,0,0-.925-4.831,9.768,9.768,0,0,0-2.3-3.526,9.7,9.7,0,0,0-3.526-2.3A14.642,14.642,0,0,0,28.108.119C25.985.02,25.31,0,19.9,0Zm0,3.583c5.312,0,5.946.027,8.044.118a10.966,10.966,0,0,1,3.694.688,6.55,6.55,0,0,1,3.778,3.777,10.989,10.989,0,0,1,.685,3.694c.095,2.1.116,2.73.116,8.044s-.025,5.946-.123,8.044a11.2,11.2,0,0,1-.7,3.694,6.32,6.32,0,0,1-1.491,2.292,6.209,6.209,0,0,1-2.289,1.486,11.07,11.07,0,0,1-3.707.685c-2.113.095-2.735.116-8.059.116s-5.948-.025-8.059-.123a11.285,11.285,0,0,1-3.709-.7A6.163,6.163,0,0,1,5.8,33.908a6.043,6.043,0,0,1-1.493-2.289,11.3,11.3,0,0,1-.7-3.707c-.075-2.09-.1-2.735-.1-8.034s.027-5.948.1-8.062a11.282,11.282,0,0,1,.7-3.705A5.9,5.9,0,0,1,5.8,5.82,5.887,5.887,0,0,1,8.086,4.331a11.016,11.016,0,0,1,3.684-.7c2.115-.075,2.737-.1,8.059-.1l.075.05Zm0,6.1A10.22,10.22,0,1,0,30.123,19.9,10.219,10.219,0,0,0,19.9,9.683Zm0,16.854A6.634,6.634,0,1,1,26.537,19.9,6.632,6.632,0,0,1,19.9,26.537ZM32.916,9.28a2.388,2.388,0,1,1-2.388-2.387A2.39,2.39,0,0,1,32.916,9.28Z",
    transform: "translate(21.845 21.845)",
    fill: "#0d9648"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_26",
    "data-name": "Ellipse 26",
    transform: "translate(0.056 0.099)",
    fill: "none",
    stroke: "#0d9648",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 42.5,
    r: 42.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 42.5,
    r: 42,
    fill: "none"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoInstagram);
export default __webpack_public_path__ + "static/media/ico-instagram.497cb6a414e5bccc701a4445d13200b8.svg";
export { ForwardRef as ReactComponent };